<template>
  <div class="confirmInformation">
    <div class="titleWap" style="margin: 0">作品信息</div>
    <div class="workInformationWap">
      <div class="listTypeOne">
        <div class="listTypeOneLeft">
          <div>作品名称</div>
          <div>{{ dataDetails.name }}</div>
        </div>
        <div class="listTypeOneRight">
          <div>作品类型</div>
          <div>
            {{
              dataDetails.type == 1
                ? "文字"
                : dataDetails.type == 2
                ? "口述"
                : dataDetails.type == 3
                ? "音乐"
                : dataDetails.type == 4
                ? "戏剧"
                : dataDetails.type == 5
                ? "曲艺"
                : dataDetails.type == 6
                ? "舞蹈"
                : dataDetails.type == 7
                ? "杂技"
                : dataDetails.type == 8
                ? "美术"
                : dataDetails.type == 9
                ? "建筑"
                : dataDetails.type == 10
                ? "摄影"
                : dataDetails.type == 11
                ? "电影"
                : dataDetails.type == 12
                ? "似摄制电影方法创作作品"
                : dataDetails.type == 13
                ? "工程设计图,产品设计图"
                : dataDetails.type == 15
                ? "地图,示意图"
                : dataDetails.type == 17
                ? "模型"
                : dataDetails.type == 19
                ? "录音作品"
                : dataDetails.type == 20
                ? "录象作品"
                : dataDetails.type == 181
                ? "其他作品"
                : dataDetails.type
            }}
          </div>
        </div>
      </div>
      <div class="listTypeTwo" v-if="dataDetails.poster">
        <div class="title">作品封面</div>
        <div class="content">
          <div>
            <img :src="dataDetails.poster" alt="cover" />
          </div>
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">创作性质</div>
        <div class="content">
          {{
            dataDetails.creation == 0 && dataDetails.worksAuthorList[0].postCode == 1
              ? "原创"
              : dataDetails.creation == 0 && dataDetails.worksAuthorList[0].postCode == 100
              ? "社创"
              : dataDetails.creation == 1
              ? "改编"
              : dataDetails.creation == 2
              ? "翻译"
              : dataDetails.creation == 3
              ? "汇编"
              : dataDetails.creation == 4
              ? "注释"
              : dataDetails.creation == 5
              ? "整理"
              : dataDetails.creation == 6
              ? "其他"
              : dataDetails.creation
          }}
        </div>
      </div>
      <!-- <div class="listTypeTwo">
        <div class="title">创作性质说明</div>
        <div class="content">
          <div>
            <img src="" alt="cover" />
          </div>
        </div>
      </div> -->
      <div class="listTypeThree">
        <div class="title">创作时间</div>
        <div class="content">{{ dataDetails.createTime }}</div>
      </div>
      <div class="listTypeThree">
        <div class="title">创作地点</div>
        <div class="content">
          {{ dataDetails.worksCreationCountry }}/{{
            dataDetails.worksCreationCity
          }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">发表状态</div>
        <div class="content">
          {{ dataDetails.worksPublishStatus == 0 ? "未发表" : "已发表" }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">发表日期</div>
        <div class="content">{{ dataDetails.worksPublishTime }}</div>
      </div>
      <div class="listTypeThree">
        <div class="title">发表地点</div>
        <div class="content">
          {{ dataDetails.worksPublishCountry }}/{{
            dataDetails.worksPublishCity
          }}
        </div>
      </div>
      <!-- <div class="imgListWapTypeOne">
        <div class="item" v-for="(item, index) in 8" :key="index">
          <div>
            <img src="" alt="" />
          </div>
          <div>作品权利保证书</div>
        </div>
      </div> -->
    </div>
    <!-- <div class="titleWap">权属信息</div>
    <div class="titleWap2">权利获得方式 <span>继承</span></div>
    <div class="multiple">
      <div class="item" v-for="(item, index) in 3" :key="index">
        <img src="" alt="" />
      </div>
    </div> -->

    <!-- <div class="titleWap2">权利生产方式 <span>合作作品</span></div>
    <div class="multiple">
      <div class="item">
        <img src="" alt="" />
      </div>
    </div> -->

    <div class="titleWap" style="marign-bottom: 0">著作权人</div>
    <div
      class="copyrightOwner"
      v-for="(item, index) in dataDetails.worksAuthorList"
      :key="index"
    >
      <div class="titleWap2">第{{ index + 1 }}位</div>
      <div class="listTypeOne">
        <div class="item">
          <div>姓名</div>
          <div>{{ item.userName }}</div>
        </div>
        <div class="item">
          <div>证件号码</div>
          <div>{{ item.idNumber }}</div>
        </div>
      </div>
      <div class="listTypeOne">
        <div class="item" v-if="item.sex">
          <div>性别</div>
          <div>{{ item.sex == "1" ? "男" : "女" }}</div>
        </div>
        <div class="item" v-if="item.ethnic">
          <div>民族</div>
          <div>{{ item.ethnic }}</div>
        </div>
      </div>
      <div class="listTypeOne" v-if="item.birthDate">
        <div class="item">
          <div>出生日期</div>
          <div>{{ item.birthDate }}</div>
        </div>
        <!-- <div class="item">
          <div>证件地址</div>
          <div>北京</div>
        </div> -->
      </div>
      <div class="listTypeOne" v-if="item.issueDate">
        <div class="item">
          <div>证件签发日期</div>
          <div>{{ item.issueDate }}</div>
        </div>
        <div class="item" v-if="item.expirationDate">
          <div>证件失效日期</div>
          <div>{{ item.expirationDate }}</div>
        </div>
      </div>
      <div
        class="listTypeTwo"
        v-if="item.cardHoldImage || item.cardBackImage || item.cardFrontImage"
      >
        <div class="title">作品封面</div>
        <div class="content">
          <div>
            <img :src="item.cardHoldImage" alt="cover" />
          </div>
          <div>
            <img :src="item.cardBackImage" alt="cover" />
          </div>
          <div>
            <img :src="item.cardFrontImage" alt="cover" />
          </div>
        </div>
      </div>
      <!-- <div class="listTypeOne">
        <div class="item">
          <div>作者</div>
          <div>张三</div>
        </div>
        <div class="item">
          <div>署名</div>
          <div>张三</div>
        </div>
      </div>
      <div class="listTypeOne">
        <div class="item">
          <div>作者</div>
          <div>张三</div>
        </div>
        <div class="item">
          <div>署名</div>
          <div>张三</div>
        </div>
      </div> -->
    </div>
    <div class="titleWap">权利人</div>
    <div
      v-for="(item, index) in dataDetails.worksAuthorList"
      :key="index"
      class="obligeeView"
    >
      <div class="obligeeWap">
        <div class="name">权利人:{{ item.userName }}</div>
        <div class="name">署名:{{ item.name }}</div>

        <!-- <div class="obligeeList">
          <el-radio-group v-model="obligee">
            <el-radio
              :label="1"
              >张三</el-radio
            >
          </el-radio-group> 
        </div>-->
      </div>
      <div class="titleWap">权利拥有情况</div>
      <div class="haveSituation">
        <div v-for="(items, indexs) in item.rightsCategoryArray" :key="indexs">
          {{
            items == 0
              ? "发表权"
              : items == 1
              ? "署名权"
              : items == 2
              ? "修改权"
              : items == 3
              ? "保护作品完整权"
              : items == 4
              ? "复制权"
              : items == 5
              ? "发行权"
              : items == 6
              ? "出租权"
              : items == 7
              ? "展览权"
              : items == 8
              ? "表演权"
              : items == 9
              ? "放映权"
              : items == 10
              ? "广播权"
              : items == 11
              ? "信息网络传播权"
              : items == 12
              ? "摄制权"
              : items == 13
              ? "改编权"
              : items == 14
              ? "翻译权"
              : items == 15
              ? "汇编权"
              : items == 16
              ? "其他"
              : items
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { ElMessage, ElLoading } from "element-plus";

import {
  articleLinkSubmit,
  articleGetWorksInfo,
  articleLinkSubmitValid,
} from "../../api/interfaceList.js";
export default {
  name: "confirmInformation",
  data() {
    return {
      dataDetails: "",
      payStatus: "",
    };
  },
  props: ["publicData"],
  computed: {
    personalType() {
      return this.publicData.personalType;
    },
  },
  watch: {
    personalType() {
        this.articleLinkSubmitValid()
      // if (this.payStatus == 1) {
      //   this.articleLinkSubmit();
      // } else {
      //   this.articleLinkSubmitValid();
      // }
    },
  },
  methods: {
    articleLinkSubmit() {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      articleLinkSubmit({
        contentUplinkCode: Cookies.get("uniqueCode"),
      }).then((res) => {
        loading.close();
        if (res.code == 1) {
          ElMessage({
            message: res.message,
            type: "success",
          });
          let json = {
            key: 5,
            isOk: true,
          };
          this.$emit("isOk", json);
        } else {
          ElMessage({
            message: res.message || "参数错误或不完整",
            type: "warning",
          });
        }
      });
    },
    articleLinkSubmitValid() {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      articleLinkSubmitValid({
        contentUplinkCode: Cookies.get("uniqueCode"),
      }).then((res) => {
        loading.close();
        if (res.code == 1) {
          ElMessage({
            message: res.message,
            type: "success",
          });
          let json = {
            key: 4,
            isOk: true,
            payStatus: this.payStatus,
          };
          this.$emit("isOk", json);
        } else {
          ElMessage({
            message: res.message || "参数错误或不完整",
            type: "warning",
          });
        }
      });
    },
    articleGetWorksInfo() {
      articleGetWorksInfo({
        contentUplinkCode: Cookies.get("uniqueCode"),
      }).then((res) => {
        this.dataDetails = res.data;
        this.payStatus = res.data.payStatus;
      });
    },
  },
  mounted() {
    this.articleGetWorksInfo();
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.confirmInformation {
  width: 712px;
  margin: auto;
  .obligeeView {
    margin-bottom: 30px;

    .obligeeWap {
      width: 526px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        width: 200px;
        height: 100%;
        font-size: 14px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }
  .btnWap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 50px 0;
    div {
      height: 40px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;
      cursor: pointer;
    }
    div:nth-of-type(1) {
      width: 120px;
      border: 1px solid #c0c4cc;
      margin-right: 72px;
      color: #909399;
    }
    div:nth-of-type(2) {
      width: 240px;
      background: #008aea;
      color: #ffffff;
    }
  }
  .haveSituation {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    div {
      padding: 8px 12px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #008aea;
      background: #f5f7fa;
      border-radius: 12px;
      margin: 0 16px 16px 0;
      font-weight: 800;
    }
  }
  .copyrightOwner {
    width: 526px;
    margin-top: 48px;
    .listTypeTwo {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      .title {
        width: 70px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 11px;
      }
      .content {
        display: flex;
        align-items: center;
        div {
          width: 144px;
          height: 96px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          overflow: hidden;
          img {
            height: 100%;
          }
        }
      }
    }
  }
  .listTypeOne {
    width: 526px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .item {
      width: 200px;
      display: flex;
      align-items: center;
      div:nth-of-type(1) {
        width: 70px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 11px;
      }
      div:nth-of-type(2) {
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }
  .multiple {
    display: flex;
    align-items: center;
    margin: 28px 0;
    .item {
      width: 160px;
      height: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 24px;
      img {
        height: 100%;
      }
    }
  }
  .workInformationWap {
    margin-top: 18px;
    .imgListWapTypeOne {
      width: 712px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        width: 160px;
        div:nth-of-type(2) {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #606266;
          margin: 4px 0 20px;
        }
        div:nth-of-type(1) {
          width: 100%;
          height: 240px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            height: 100%;
          }
        }
      }
    }
    .listTypeThree {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .title {
        width: 64px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 18px;
      }
      .content {
        width: 416px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
    .listTypeTwo {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .title {
        width: 64px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 18px;
      }

      .content {
        width: 144px;
        height: 96px;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          width: 100%;
          height: 100%;
          overflow:hidden;
          img {
            height: 100%;
          }
        }
      }
    }
    .listTypeOne {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .listTypeOneRight {
        display: flex;
        align-items: center;
        margin-left: 140px;
        div:nth-of-type(1) {
          width: 64px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          margin-right: 18px;
        }
        div:nth-of-type(2) {
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #606266;
        }
      }
      .listTypeOneLeft {
        display: flex;
        align-items: center;
        div:nth-of-type(1) {
          width: 64px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          margin-right: 18px;
        }
        div:nth-of-type(2) {
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #606266;
        }
      }
    }
  }
  .titleWap {
    font-size: 18px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    margin: 30px 0 18px;
    font-weight: 800;
    .styleCss {
      margin: 50px 0 00;
    }
  }
  .titleWap2 {
    font-size: 12px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    margin-bottom: 20px;
    span {
      margin-left: 11px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #606266;
    }
  }
}
</style>
